/**
 * Registers the offline service worker (public/sw.js). Production only —
 * in dev, public/sw.js still contains the unreplaced __CACHE_VERSION__
 * placeholder (only `npm run build`'s postbuild step stamps a real one),
 * and CRA's dev server / HMR has no need for it anyway.
 */
export function registerServiceWorker(): void {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  navigator.serviceWorker.register("/sw.js").catch((err) => {
    console.error("[offline] service worker registration failed", err);
  });
}
